module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "students-leadership-potential.785589ed.jpeg" + "?" + Date.now();